<template src="./component.html"></template>

<script>

export default {
  name: "NotfoundPage",
  components: {},
}
</script>

<style src="./component.scss" scoped lang="scss"/>
